import { render } from "./PickerYear.vue?vue&type=template&id=595a90f4"
import script from "./PickerYear.vue?vue&type=script&lang=js"
export * from "./PickerYear.vue?vue&type=script&lang=js"
script.render = render

export default script